<template>
    <div>

        <transition name="fade" mode="out-in">
            <nuxt/>
        </transition>

    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>
